<template>
    <div style="width:100%;" v-if="$parent.isDetailsClick">

        <div class="order_history_main_area">

            <div class="payment_countdown_bar" v-if="checkInCompletePaymentObj()">
                <div class="text1">{{label['order_retry_text_countdown_text']}}</div>
                <div class="text2">{{$root.inCompletePaymentObj.countdownMin}}:{{$root.inCompletePaymentObj.countdownSec}}</div>
            </div>

            <div class="order_history_main_content_area order_details" :class="{isCountDown : checkInCompletePaymentObj() }" v-if="isLoadOrder && orderData != null">
                <div class="order_history_header_div">{{label['order_history_text_header']}}</div>

                <div class="order_details_top_div">
                    <div class="order_details_top_content_div order_status">{{$parent.orderStatusDisplayChecking(order, order.orderStatus,order.eventObj.eventStatus)}}</div>
                    <div class="order_details_top_content_div">{{label['order_history_text_order_no']}}: {{order.orderCode}}</div>
                    <div class="order_details_top_content_div">{{label['order_history_text_order_date']}}: {{$root.writeDisplayDatetimeFormat2(order.createDate)}}</div>
                </div>
                <!-- order_details_top_div end -->

                <div class="order_details_event_title_div">
                    <div class="event_image_div">
                        <img :src="event.eventImages[0]" align="absmiddle" />
                    </div>
                    <div class="event_title_div">
                        {{event.eventTitle}}
                    </div>
                </div>
                <!-- order_details_event_title_div -->

                <div class="order_details_event_info_div">

                    <div class="event_image_div">
                        <img :src="event.eventImages[0]" align="absmiddle" />
                    </div>
                    <div class="order_details_event_info_content_div">

                        <!--<div class="event_info_tag full mall">
                            <div class="event_info_tag_inner_div">
                                <div class="tag_icon"></div>
                                <div class="tag_content">
                                    <div class="tag_title">{{label['event_common_text_mall']}}</div>
                                    <div class="tag_content_text" v-html="event.mall.mallName"></div>
                                </div>
                            </div>
                        </div>-->

                        <div class="event_info_tag full date">
                            <div class="event_info_tag_inner_div">
                                <div class="tag_icon"></div>
                                <div class="tag_content">
                                    <div class="tag_title">{{label['event_common_text_date']}}</div>
                                    <div class="tag_content_text" v-html="selectEventSessionDateTime(false)"></div>
                                </div>
                            </div>
                        </div>

                        <div class="event_info_tag full venue">
                            <div class="event_info_tag_inner_div">
                                <div class="tag_icon"></div>
                                <div class="tag_content">
                                    <div class="tag_title">{{label['event_common_text_venue']}}</div>
                                    <div class="tag_content_text" v-html="$root.selectEventLocationDisplay(event.location)" v-if="event.location.length > 0"></div>
                                    <div class="tag_content_text" v-html="event.locationDetails" v-if="event.locationDetails != ''"></div>
                                    <div class="tag_extra" @click="openHowToGetThere()" v-if="event.howToGetThere != ''">{{label['event_common_text_venue_how_to_get_there']}}</div>

                                    <div class="tag_google_map" v-if="event.mettingPointlong != ''">
                                        <div class="tag_google_map_text">{{label['event_details_text_ExternalMeetingPoint']}}</div>
                                        <div class="tag_google_map_btn">
                                            <a :href="$root.writeGoogleMapPath(event.mettingPointlong,event.mettingPointlat)" target="_blank">{{label['event_details_text_GoogleMap']}}</a>
                                        </div>
                                    </div>
                                    <div class="tag_content_text" v-html="event.mettingPointAddress" v-if="event.mettingPointAddress != ''"></div>
                                </div>
                            </div>
                        </div>

                        <div class="event_info_tag quantity">
                            <div class="event_info_tag_inner_div">
                                <div class="tag_icon"></div>
                                <div class="tag_content">
                                    <div class="tag_title">{{label['event_common_text_quantity']}}</div>
                                    <div class="tag_content_text" v-html="selectEventQuantity"></div>
                                </div>
                            </div>
                        </div>

                        <div class="event_info_tag language" v-if="selectEventLanguageDisplay != ''">
                            <div class="event_info_tag_inner_div">
                                <div class="tag_icon"></div>
                                <div class="tag_content">
                                    <div class="tag_title">{{label['event_common_text_language']}}</div>
                                    <div class="tag_content_text" v-html="selectEventLanguageDisplay"></div>
                                </div>
                            </div>
                        </div>

                        <div class="event_info_tag username">
                            <div class="event_info_tag_inner_div">
                                <div class="tag_icon"></div>
                                <div class="tag_content">
                                    <div class="tag_title">{{label['checkout_text_username']}}</div>
                                    <div class="tag_content_text" v-html="order.memberName"></div>
                                </div>
                            </div>
                        </div>

                        <div class="event_info_tag phone">
                            <div class="event_info_tag_inner_div">
                                <div class="tag_icon"></div>
                                <div class="tag_content">
                                    <div class="tag_title">{{label['checkout_text_phoneno']}}</div>
                                    <div class="tag_content_text" v-html="order.memberPhone"></div>
                                </div>
                            </div>
                        </div>

                        <div class="event_info_tag full email">
                            <div class="event_info_tag_inner_div">
                                <div class="tag_icon"></div>
                                <div class="tag_content">
                                    <div class="tag_title">{{label['checkout_text_email']}}</div>
                                    <div class="tag_content_text" v-html="order.memberEmail"></div>
                                </div>
                            </div>
                        </div>

                    </div> <!-- order_details_event_info_content_div end -->
                </div><!-- order_details_event_info_div end -->
                

                <div class="order_details_paymethod" v-if="order.paymentType != ''">
                    <div class="paymethod_title">{{label['checkout_text_paymethod']}}</div>

                    <div class="paymethod_content_div">
                        <div class="paymethod_name_div">{{orderPayMethodName(order.paymentType, order.paymentCardType)}}</div>
                        <div class="order_price_div"><money :price="order.finalPrice" /></div>
                    </div>

                </div><!-- order_details_paymethod end -->


                <div style="width:100%" v-if="checkOrderTicketDisplay()">

                    <div class="order_details_ticket_div" v-if="!order.eventObj.auto_attend_event">
                        <div class="ticket_title">{{label['order_history_text_order_ticket_list_title']}}</div>

                        <div class="ticket_list_div">
                        
                            <div class="ticket_list_row"
                                 v-for="(ticket, index) in order.orderTicket"
                                 :key="'t'+index"
                                >
                                <div class="ticket_info_div">
                                    <div class="ticket_name_div">
                                        <div class="ticket_name">{{$root.writePriceTagName(ticket)}} - {{ticket.ticketNo}}</div>
                                        <div class="is_share" v-if="ticket.isShare == 1">{{label['order_history_text_order_ticket_shared']}}</div>
                                    </div>
                                    <div class="ticket_btn_div">
                                        <div class="ticket_btn share_btn" :class="{isShare : ticket.isShare == 1}" @click="openShareTicketQRCode(ticket)">{{label['order_history_text_order_ticket_share']}}</div>
                                        <div class="ticket_btn view_btn" @click="openTicketQRCode(ticket)">{{label['order_history_text_order_ticket_view']}}</div>
                                    </div>
                                </div>
                                <div class="ticket_share_div" v-if="ticket.isShare == 1">
                                    {{ticket.shareEmail}}
                                </div>
                            </div>

                        </div><!-- ticket_list_div end -->

                    </div><!-- order_details_ticket_div end -->

                    <div class="order_details_ticket_div" v-if="order.eventObj.auto_attend_event">
                        <!--<div class="ticket_title">{{label['event_common_text_email_auto_attend_ticket_title']}}</div>-->
                    </div><!-- order_details_ticket_div end -->

                </div> <!-- if order is complete end -->

                <div style="width:100%" v-if="order.orderStatus == 'payment' && checkInCompletePaymentObj()">
                    <div class="order_payment_btn retry" @click="retryMemberPaymentClick()">
                        {{label['order_retry_text_retry']}}
                    </div>
                    <div class="order_payment_btn cancel" @click="cancelMemberPaymentClick()">
                        {{label['order_retry_text_cancel_payment']}}
                    </div>
                </div> <!-- if order is in payment end -->

                <div style="width:100%" v-if="order.orderStatus == 'waiting' && order.allowReSubmit">
                    <div class="order_payment_btn retry" @click="ReSubmitMemberOrderClick()">
                        {{label['checkout_text_submit_btn']}}
                    </div>
                </div> <!-- if order is in payment end -->

                <div style="width:100%" v-if="order.orderStatus == 'complete' && order.totalPrice == 0">
                    <div class="order_payment_btn retry" @click="MemberCancelOrderConfirm()">
                        {{label['orderDetails_member_cancel_order_btn']}}
                    </div>
                </div> <!-- if order is free event end -->

            </div>
            <!--order_history_content_div end orderNo != null -->


            <div class="order_history_main_content_area order_details" v-if="isLoadOrder && orderData == null">
                <div class="order_history_header_div">{{label['order_history_page_order_not_found_header_text']}}</div>
            </div>
            <!-- orderNo == null -->

        </div>

        
        <!-- HowToGetThere start -->
        <transition name="slide-up">
            <div class="how_to_get_there_div" v-if="isOpenHowToGetThere" :style="{'height':$root.full_screen_height.height_fix}">
                <div class="how_to_get_there_div_background" @click="closeHowToGetThere()" :style="{'height':$root.full_screen_height.height_fix}"></div>

                <div class="how_to_get_there_div_layer">
                    <div class="how_to_get_there_inner_div">
                        <div class="how_to_get_there_top_div">
                            <div class="close_icon" @click="closeHowToGetThere()"></div>
                        </div>
                        <div class="how_to_get_there_middle_div">
                            <div class="header_div">
                                {{label['event_common_text_venue_how_to_get_there_layer_title']}}
                            </div>
                            <div class="body_div">
                               
                                <div class="image_div">
                                    <img :src="event.howToGetThere" align="absmiddle" />
                                </div>
                                <div class="location_div">
                                    <div class="location_icon"></div>
                                    <div class="location_content">
                                        <div class="location_title">
                                            {{label['event_common_text_venue']}}
                                        </div>
                                        <div class="location_content_text" v-html="event.location.locationName" v-if="event.location.locationName != ''"></div>
                                        <div class="location_content_text" v-html="event.locationDetails" v-if="event.locationDetails != ''"></div>
                                    </div>
                                </div>

                            </div>
                        </div>                       
                    </div>

                </div>

            </div>
        </transition>
        <!-- HowToGetThere end -->


        <!-- ticket_qrcode start -->
        <transition name="slide-up">
            <div class="ticket_qrcode_div" v-if="isOpenTicketQRCode" :style="{'height':$root.full_screen_height.height_fix}">

                <div class="ticket_qrcode_div_layer">
                    <div class="ticket_qrcode_inner_div">
                        <div class="ticket_qrcode_top_div">
                            <div class="close_icon" @click="closeTicketQRCode()"></div>
                        </div>
                        <div class="ticket_qrcode_middle_div">
                            <div class="header_div">
                                {{label['order_history_text_qrcode']}}
                            </div>
                            <div class="body_div">

                                <div class="event_title_div">
                                    <div class="event_image_div">
                                        <img :src="event.eventImages[0]" align="absmiddle" />
                                    </div>
                                    <div class="event_title_div_text">
                                        {{event.eventTitle}}
                                    </div>
                                </div>

                                <div class="info_data_div">

                                    <div class="datetime_div">
                                        <div class="datetime_outer_div">
                                            <div class="datetime_icon"></div>
                                            <div class="datetime_content">
                                                <div class="datetime_title">{{label['event_common_text_date']}}</div>
                                                <div class="datetime_content_text" v-html="selectEventSessionDateTime(true)"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ticketname_div">
                                        <div class="ticketname_text">
                                            {{$root.writePriceTagName(selectTicketObj)}} - {{selectTicketObj.ticketNo}}
                                        </div>
                                    </div>

                                </div>

                                <div class="image_div">
                                    <img :src="selectTicketObj.ticketPath" align="absmiddle" />
                                </div>

                                <div class="ticket_code_div">{{selectTicketObj.ticketCode}}</div>

                            </div>
                        </div>                       
                    </div>

                </div>

            </div>
        </transition>
        <!-- ticket_qrcode end -->


        <!-- ticket_share start -->
        <transition name="slide-up">
            <div class="ticket_share_div_form_layer" v-if="isOpenShareTicketQRCode" :style="{'height':$root.full_screen_height.height_fix}">

                <div class="ticket_share_div_layer">
                    <div class="ticket_share_inner_div">
                        <div class="ticket_share_top_div">
                            <div class="close_icon" @click="closeShareTicketQRCode()"></div>
                        </div>
                        <div class="ticket_share_middle_div">
                            <div class="header_div">
                                {{label['order_history_text_qrcode']}}
                            </div>
                            <div class="body_div">

                                <div class="event_title_div">
                                    <div class="event_image_div">
                                        <img :src="event.eventImages[0]" align="absmiddle" />
                                    </div>
                                    <div class="event_title_div_text">
                                        {{event.eventTitle}}
                                    </div>
                                </div>

                                <div class="info_data_div">

                                    <div class="datetime_div">
                                        <div class="datetime_outer_div">
                                            <div class="datetime_icon"></div>
                                            <div class="datetime_content">
                                                <div class="datetime_title">{{label['event_common_text_date']}}</div>
                                                <div class="datetime_content_text" v-html="selectEventSessionDateTime(true)"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ticketname_div">
                                        <div class="ticketname_text">
                                            {{$root.writePriceTagName(selectTicketObj)}} - {{selectTicketObj.ticketNo}}
                                        </div>
                                    </div>

                                </div>

                                <div class="ticket_code_div">{{selectTicketObj.ticketCode}}</div>

                                <form autocomplete="off" class="ticket_share_form" @submit="(e)=>{e.preventDefault();shareTicketQRCodeSubmit();}">
                                    <div class="ticket_share_form_div">

                                        <div class="ticket_share_form_row">
                                            <div class="form_title_div">{{label['order_history_text_share_qrcode_email']}}</div>
                                            <div class="form_input_div">
                                                <input type="email" id="shareEmail" v-model="shareTicketForm.shareEmail" :placeholder="label['order_history_text_share_qrcode_email']" maxlength="100" class="required validate-email" />
                                            </div>
                                        </div>

                                        <div class="ticket_share_form_row">
                                            <div class="form_title_div">{{label['order_history_text_share_qrcode_reemail']}}</div>
                                            <div class="form_input_div">
                                                <input type="email" id="confirmShareEmail" v-model="shareTicketForm.confirmShareEmail" :placeholder="label['order_history_text_share_qrcode_reemail']" maxlength="100" class="required validate-email" />
                                            </div>
                                        </div>

                                        <!--<div class="ticket_share_form_row">
                                            <div class="form_title_div">{{label['order_history_text_share_qrcode_Phone']}}*</div>
                                            <div class="form_input_div muti">
                                                <div class="form_input_select">
                                                    <select class="" v-model="shareTicketForm.sharePhoneCountry">
                                                        <option class=""
                                                                v-for="(i, index) in phoneCountryList"
                                                                :value="i"
                                                                >
                                                            {{ i }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="form_input_text">
                                                    <input type="number" id="sharePhone" v-model="shareTicketForm.sharePhone" :placeholder="label['order_history_text_share_qrcode_Phone']" maxlength="15" class="required validate-postive"
                                                        oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                           />
                                                </div>                                                
                                            </div>
                                        </div>-->

                                    </div>

                                    <div class="ticket_share_form_btn_div">
                                        <input type="submit" :value="label['order_history_text_share_qrcode_Confirm']" class="ticket_share_form_btn" :class="{active : checkCanSubmitShareTicket(false)}" />
                                    </div>
                                </form>

                            </div>
                        </div>                       
                    </div>

                </div>

            </div>
        </transition>
        <!-- ticket_share end -->


    </div>
</template>

<script>

    export default {
        data() {
            return {
                orderData: null,
                orderNo: undefined,
                isLoadOrder: false,

                isOpenHowToGetThere: false,

                isOpenTicketQRCode: false,
                selectTicketObj: null,
                isOpenShareTicketQRCode: false,
                shareTicketForm: {
                    shareEmail: "",
                    confirmShareEmail: "",
                    sharePhone: "",
                    sharePhoneCountry: ""
                },

                payMethodList: [],
                phoneCountryList: [ "+852" ],
            };
        },
        computed: {
            info() {
                return this.$root.info;
            },
            label() {
                return this.$root.getLabel();
            },
            order() {
                return this.orderData;
            },
            event() {
                return this.orderData.eventObj;
            },                    
            selectEventQuantity() {
                var app = this;
                var display_text = "";
                $.each($(this.order.orderPriceTag), function (key, tag) {
                    display_text = display_text + (display_text == "" ? "" : "<br/>") + app.$root.writePriceTagName(tag) + " x " + tag.qty;
                });
                return display_text;
            },            
            selectEventLanguageDisplay() {
                var app = this;
                var languageDisplay = "";
                $.each(this.event.language, function (key, value) {
                    if (app.info.lang == "tc" || app.info.lang == "sc") {
                        languageDisplay = languageDisplay + (languageDisplay == "" ? "" : "、") + value.languageName;
                    }
                    else {
                        languageDisplay = languageDisplay + (languageDisplay == "" ? "" : ", ") + value.languageName;
                    }
                });
                /*
                if (languageDisplay == "")
                    languageDisplay = this.label['event_common_text_language_NotSpecified'];
                */
                return languageDisplay;
            }
        },
        components: { },
        created() {
            if (this.$route.params.orderNo == undefined) {
                this.$router.replace(`/` + this.info.lang + `/member/eventhistory`);
                return;
            }
            else {
                this.$parent.isDetailsClick = true; // for going to details page directly
                this.orderNo = this.$route.params.orderNo;
            }

            this.$root.getCurrentPathName();
            if (this.info.member != null) {

                //this.info.loading = false;           

                this.GetPayMethodList();
                //this.GetPhoneCountryList();

                this.$root.setGoBackAction(this.goBack);

            }
            else {
                //this.$router.replace(`/` + this.info.lang + "/");
                this.$root.LoginBtnClick();
            }
        },
        destroyed() {
            this.resetOrderDetaisData();
            this.$root.setGoBackAction();
        },
        mounted() {
            this.initOrderDetails();
        },
        watch: {
            '$root.info.lang': function (lang) {
                this.$parent.GetMemberOrderList();
                this.initOrderDetails();
            },
            '$route.params.orderNo': function (orderNo) {
                this.orderNo = orderNo;
                this.initOrderDetails();
            },
        },
        methods: {
            getItemSubfix() {
                return this.$root.getItemSubfix();
            },
            orderSessionStatusDisplayText(status) {
                var re = "";
                switch (status) {
                    case "cancel":
                        re = this.label['order_history_details_session_status_text_cancel'];
                        break;

                    case "reschedule":
                        re = this.label['order_history_details_session_status_text_reschedule'];
                        break;

                    case "refund":
                        re = this.label['order_history_details_session_status_text_refund'];
                        break;


                    default:
                        break;
                }

                return re;
            },
            selectEventSessionDateTime(newLine) {
                var app = this;
                var display_text = "";
                var statusClass = "";
                var statusLabel = "";
                $.each($(app.order.orderSession), function (key, tag) {
                    statusClass = "";
                    if (tag.rescheduleId > 0) {
                        statusClass = "reschedule";
                    }
                    if (tag.orderSessionStatus == "cancel") {
                        statusClass = "cancel";
                    }
                    statusLabel = app.orderSessionStatusDisplayText(statusClass);
                    display_text = display_text + "<div class=\"session_datetime_row " + statusClass + "\">" +
                        (app.order.orderSession.length > 1 ? "<div class=\"row_no\">" + (key + 1) + "</div>" : "") +
                        "<div class=\"row_text\">" +
                        "<div class=\"row_text_a\">" +
                        (app.$root.writeDisplayDateFormat(tag.eventDate) + (newLine ? "<br/>" : " ") + app.$root.sessionTimeFormat(tag.eventStartTime) + " - " + app.$root.sessionTimeFormat(tag.eventEndTime)) +
                        app.$root.selectSessionSessionRemarkDisplay(tag, true) + 
                        (statusLabel == "" ? "" : " (" + statusLabel + ")") +
                        "</div>";

                    if (tag.rescheduleId > 0) {
                        display_text = display_text + "<div class=\"row_text_b\">" +
                            app.label['order_history_details_session_status_text_reschedule_from'] + " " +
                            (app.$root.writeDisplayDateFormat(tag.eventDateFrom) + (newLine ? "<br/>" : " ") + app.$root.sessionTimeFormat(tag.eventStartTimeFrom) + " - " + app.$root.sessionTimeFormat(tag.eventEndTimeFrom)) +
                            + app.$root.selectSessionSessionRemarkDisplay(tag, true)
                            "</div>";
                    }

                    display_text = display_text + "</div></div>";
                });
                return display_text;
            },
            checkInCompletePaymentObj() {
                if (this.$root.inCompletePaymentObj.countdownDisplay && (this.$root.inCompletePaymentObj.paymentObj != null && this.$root.inCompletePaymentObj.paymentObj.paymentCode == this.orderNo)) {
                    return true;
                }
                else {
                    return false;
                }
            },
            RunCheckInCompletePaymentTimeout(forceRun) {
                var app = this;

                // check timer within 5 min = 300000 millisec
                if (forceRun) {
                    app.$root.checkMemberContainsInCompletePayment(app.order.orderCode);
                    window.setTimeout(function () { app.RunCheckInCompletePaymentTimeout(false); }, 300000);
                }
                else {
                    if (app.checkInCompletePaymentObj()) {
                        app.$root.checkMemberContainsInCompletePayment(app.order.orderCode);
                        window.setTimeout(function () { app.RunCheckInCompletePaymentTimeout(false); }, 300000);
                    }
                }                
            },

            GetPayMethodList() {
                var app = this;
                this.$root.wsGet(app.info.wsUrl + "/Order/GetPaymentTypeList", app.$root.info.lang, function (data) {
                    if (data.status == 0) {
                        app.payMethodList = data.paymentTypeList;
                    }
                });
            },
            GetPhoneCountryList() {
                var app = this;
                this.$root.wsGet(app.info.wsUrl + "/Other/GetPhoneCountryCode", app.$root.info.lang, function (data) {
                    if (data.status == 0) {
                        app.phoneCountryList = data.countryCode;
                        app.shareTicketForm.sharePhoneCountry = app.phoneCountryList[0];
                    }
                });
            },
            orderPayMethodName(paymethodCode, paymentCardType) {
                if (paymentCardType == "") {
                    var pay = $(this.payMethodList).filter((i, o) => o["code"] == paymethodCode);
                    if (pay.length > 0) {
                        return pay[0]["name" + this.getItemSubfix()];
                    }
                    else {
                        return paymethodCode;
                    }
                }
                else {
                    return (this.label['order_history_order_payment_card_type_' + paymentCardType] || paymentCardType)
                }
            },
            checkOrderTicketDisplay() {

                if (this.order.orderStatus == 'complete') {
                    if (!this.order.isPass) {
                        return true;
                    }
                    else {
                        return false;
                    }                    
                }
                else {
                    return false;
                }

            },

            initOrderDetails() {
                // check parent contains order list
                if (this.$parent.orderList == null) {
                    setTimeout(this.initOrderDetails, 100);
                }
                else {
                    this.LoadOrderDetailsData();
                }
            },
            LoadOrderDetailsData() {
                var app = this;
                //app.info.loading = true;

                $.ajax({
                    type: "POST",
                    headers: { lang: app.info.lang, memberToken: app.info.member.memberToken },
                    url: app.info.wsUrl + "/Order/GetMemberOrderDetails",
                    contentType: "application/json",
                    data: JSON.stringify({ "orderCode": app.orderNo }),
                    dataType: "json",
                    success: (data) => {
                        console.log("GetMemberOrderDetails", data);

                        if (data.status == 0) {
                            app.orderData = data.orderCore;

                            //if (app.order.orderStatus == "payment") {
                                //app.$root.checkMemberContainsInCompletePayment(app.order.orderCode);
                                app.RunCheckInCompletePaymentTimeout(true);
                            //}
                        }
                        else {

                            if (data.status == 98) {
                                app.$root.removeInfoMemberData();
                                //app.$root.ReloadCurrentPage();
                            }
                            else {
                                app.$root.alert(data.detail);
                            }
                            
                        }

                        app.info.loading = false;
                        app.isLoadOrder = true;
                    }
                });
            },

            goBack() {
                this.resetOrderDetaisData();
                //this.$router.push(`/` + this.info.lang + `/member/eventhistory`);
                this.$router.go(-1);
                return true;
            },
            resetOrderDetaisData() {
                this.orderData = null;
                this.orderNo = undefined;
                this.$parent.isDetailsClick = false;
            },

            openHowToGetThere() {
                this.isOpenHowToGetThere = true;
                this.$root.setBodyOverflow(true);
            },
            closeHowToGetThere() {
                this.isOpenHowToGetThere = false;
                this.$root.setBodyOverflow(false);
            },

            openTicketQRCode(ticketObj) {
                this.isOpenTicketQRCode = true;
                this.selectTicketObj = ticketObj;
                this.$root.setBodyOverflow(true);
            },
            closeTicketQRCode() {
                this.isOpenTicketQRCode = false;
                this.selectTicketObj = null;
                this.$root.setBodyOverflow(false);
            },

            openShareTicketQRCode(ticketObj) {
                if (ticketObj.isShare == 0) {
                    this.isOpenShareTicketQRCode = true;
                    this.selectTicketObj = ticketObj;
                    this.$root.setBodyOverflow(true);
                }
            },
            closeShareTicketQRCode() {
                this.isOpenShareTicketQRCode = false;
                this.selectTicketObj = null;
                this.shareTicketForm = {
                    shareEmail: "",
                    confirmShareEmail: "",
                    sharePhone: "",
                    sharePhoneCountry: this.phoneCountryList[0]
                };
                this.$root.setBodyOverflow(false);
            },
            checkCanSubmitShareTicket(isAlert) {
                var re = false;
                
                //if (this.shareTicketForm.shareEmail != "" && this.shareTicketForm.confirmShareEmail != "" && this.shareTicketForm.sharePhone != "") {
                if (this.shareTicketForm.shareEmail != "" && this.shareTicketForm.confirmShareEmail != "") {
                    if (this.shareTicketForm.shareEmail == this.shareTicketForm.confirmShareEmail) {
                        re = true;
                    }
                    else {
                        if (isAlert) {
                            this.$root.alert(this.label['order_history_text_share_qrcode_email_same_as_reemail']);
                        }
                    }
                }

                return re;
            },
            shareTicketQRCodeSubmit() {
                var app = this;

                if (this.checkCanSubmitShareTicket(true)) {
                    if (!MyValidation.ThisCustom(this.$el.querySelector("#shareEmail"), false)) {
                        this.$root.alert(this.label['order_history_text_share_qrcode_incorrect_email']);
                    }
                    /*else if (!MyValidation.ThisCustom(this.$el.querySelector("#sharePhone"), false)) {
                        this.$root.alert(this.label['order_history_text_share_qrcode_incorrect_Phone']);
                    }*/
                    else {
                        //console.log("this.shareTicketForm", this.shareTicketForm);
                        app.info.loading = true;
                        
                        $.ajax({
                            type: "POST",
                            headers: { lang: app.info.lang, memberToken: app.info.member.memberToken },
                            url: app.info.wsUrl + "/Order/MemberOrderTicketShare",
                            contentType: "application/json",
                            //data: JSON.stringify({ "orderCode": app.orderNo, "Ticket": app.selectTicketObj.ticketId, "Name": app.selectTicketObj.memberName, "Email": app.shareTicketForm.shareEmail, "Phone": app.shareTicketForm.sharePhoneCountry + "" + app.shareTicketForm.sharePhone }),
                            data: JSON.stringify({ "orderCode": app.orderNo, "Ticket": app.selectTicketObj.ticketId, "Name": app.selectTicketObj.memberName, "Email": app.shareTicketForm.shareEmail, "Phone": app.selectTicketObj.memberPhone }),
                            dataType: "json",
                            success: (data) => {
                                console.log("MemberOrderTicketShare", data);

                                if (data.status == 0) {
                                    app.$root.alert(app.label['order_history_text_share_ticket_is_done']);
                                    app.selectTicketObj.isShare = 1;
                                    app.selectTicketObj.shareName = app.selectTicketObj.memberName + "";
                                    app.selectTicketObj.shareEmail = app.shareTicketForm.shareEmail + "";
                                    //app.selectTicketObj.sharePhone = app.shareTicketForm.sharePhoneCountry + "" + app.shareTicketForm.sharePhone + "";
                                    app.selectTicketObj.sharePhone = "";
                                    app.closeShareTicketQRCode();
                                }
                                else {

                                    if (data.status == 1) {
                                        app.$root.alert(app.label['order_history_text_error_order_not_found']);
                                        app.$router.replace(`/` + app.info.lang + `/member/eventhistory`);
                                    }
                                    else {
                                        app.$root.alert(data.detail);
                                    }

                                }

                                app.info.loading = false;
                            }
                        });
                        
                    }

                }

            },

            // retry payment start
            retryMemberPaymentClick() {
                var app = this;
                var gathis = this;

                if (app.order.orderStatus == "payment") {
                    var paymentObj = app.order;
                    this.info.loading = true;
                    $.ajax({
                        type: "POST",
                        headers: { lang: app.info.lang, memberToken: app.info.member.memberToken },
                        url: app.info.wsUrl + "/Member/MemberRetryPayment?order=" + encodeURIComponent(paymentObj.orderEncode),
                        async: true,
                        contentType: "application/json",
                        data: JSON.stringify(),
                        dataType: "json",
                        success: (data) => {
                            console.log("MemberRetryPayment", data);                            

                            if (data.status == 0) {
                                //window.setTimeout(function () { window.history.go(1); }, 1000); // for checking window back
                                //window.setInterval(function () { window.history.go(1); }, 1000); // for checking window back
                                window.setTimeout(function () { app.$root.ReloadCurrentPage(); }, 5000); // for checking window back


                                gathis.$root.NFGA_FillParamCB(function () {

                                    var url = data.paymentUrl;
                                    if (data.paymentAction == "post") {
                                        $('<form method="POST">').attr("action", url).appendTo('body').submit();
                                    }
                                    else {
                                        if (url.indexOf("http") != 0) url = app.info.wsHost + url;
                                        window.location = url;
                                    }
                                    return;

                                },
                                "NFGA_retry_payment", "'" + app.order.eventObj.eventTitleEN.replace(/\'/g, "\\\'") + "'", "'" + app.order.eventObj.mall.NFMallID + "'", "'" + app.order.eventObj.mall.mallName.replace(/\'/g, "\\\'") + "'", "'" + app.order.orderCode + "'");

                            } else {

                                app.info.loading = false;
                                if (data.status == 98) {
                                    app.$root.alert(data.detail);
                                    app.$root.removeInfoMemberData();
                                    //app.$root.ReloadCurrentPage();
                                } else {

                                    if (data.status == 4) {
                                        app.$root.alert(app.label['order_retry_text_error_not_a_pending_payment']);
                                    } else if (data.status == 5) {
                                        app.$root.alert(app.label['order_retry_text_error_retry_times_is_over']);
                                    } else if (data.status == 6) {
                                        app.$root.alert(app.label['order_retry_text_error_payment_is_complete']);
                                    } else {
                                        app.$root.alert(data.detail);
                                    }
                                    this.$parent.GetMemberOrderList();
                                    this.initOrderDetails();

                                }

                            }

                        },
                    });
                }
            },
            cancelMemberPaymentClick() {
                var app = this;

                var gathis = this;
                gathis.$root.NFGA_FillParam("NFGA_cancel_payment", "'" + app.order.eventObj.eventTitleEN.replace(/\'/g, "\\\'") + "'", "'" + app.order.eventObj.mall.NFMallID + "'", "'" + app.order.eventObj.mall.mallName.replace(/\'/g, "\\\'") + "'", "'" + app.order.orderCode + "'");

                app.$root.setConfirmMsg(app.label["order_retry_text_confirm_cancel_payment"],
                    function () {
                        app.$root.cancelMemberInCompletePayment(app.order, app.cancelMemberPaymentClickCb);
                        this.$root.inCompletePaymentObj = {
                            paymentObj: null,
                            countdownMin: "00",
                            countdownSec: "00",
                            countdownDisplay: false
                        };   
                }, undefined);
            },
            cancelMemberPaymentClickCb(data) {
                var app = this;
                var gathis = this;

                if (data.status == 0) {
                    
                    gathis.$root.NFGA_FillParam("NFGA_confirm_cancel", "'" + app.order.eventObj.eventTitleEN.replace(/\'/g, "\\\'") + "'", "'" + app.order.eventObj.mall.NFMallID + "'", "'" + app.order.eventObj.mall.mallName.replace(/\'/g, "\\\'") + "'", "'" + app.order.orderCode + "'");

                    app.$parent.GetMemberOrderList();
                    app.initOrderDetails();
                } else {
                    if (data.status == 6) {
                        app.$root.alert(app.label['order_retry_text_error_payment_is_complete']);
                        app.$parent.GetMemberOrderList();
                        app.initOrderDetails();
                    } else if (data.status == 98) {
                        app.$root.alert(data.detail);
                        app.$root.removeInfoMemberData();
                        //app.$root.ReloadCurrentPage();
                    } else {
                        app.$root.alert(data.detail);
                    }
                }
                app.$root.checkMemberContainsInCompletePayment();

            },
            // retry payment end

            // resubmit order start
            ReSubmitMemberOrderClick() {
                var app = this;
                app.$root.setOrderData(app.order, false);
                app.$router.push(`/` + this.info.lang + `/checkout`);
            },
            // resubmit order end

            // member cancel order start
            MemberCancelOrderConfirm() {
                var app = this;
                if (app.order.orderStatus == 'complete' && app.order.totalPrice == 0) {
                    app.$root.setConfirmMsg(app.label["orderDetails_member_cancel_order_Confirm_Message"], app.MemberCancelOrder, undefined);
                }
            },
            MemberCancelOrder() {
                var app = this;
 
                this.info.loading = true;
                $.ajax({
                    type: "POST",
                    headers: { lang: app.info.lang, memberToken: app.info.member.memberToken },
                    url: app.info.wsUrl + "/Order/OrderCancelByMember?orderCode=" + encodeURIComponent(app.order.orderCode),
                    async: true,
                    contentType: "application/json",
                    data: JSON.stringify(),
                    dataType: "json",
                    success: (data) => {
                        console.log("OrderCancelByMember", data);

                        if (data.status == 0) {
                            app.$root.alert(app.label['orderDetails_member_cancel_order_success']);
                            this.$parent.GetMemberOrderList();
                            this.initOrderDetails();
                        } else {
                            if (data.status == 1) {
                                app.$root.alert(app.label['orderDetails_member_cancel_order_fail_order_not_found']);
                            } else if (data.status == 2) {
                                app.$root.alert(app.label['orderDetails_member_cancel_order_fail_free_event_only']);
                            } else if (data.status == 98) {
                                app.$root.removeInfoMemberData();
                                app.$root.ReloadCurrentPage();
                            } else {
                                app.$root.alert(data.detail);
                            }
                        }

                        this.info.loading = false;
                    },
                });
            },
            // member cancel order end

        },
    };
</script>
